import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { capitalize } from "@mui/material";
import { Link } from "react-router-dom";
import { SendPostRequest } from "../../http";
import HeaderWrapper from "../Header/HeaderWrapper";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";
import Spinner from "../Spinner";
import FooterWrapper from "../Footer/FooterWrapper";

function FullWidthGridGallery() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [galleryData, setGalleryData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    getGalleyData();
  }, []);

  const [isData, setIsData] = useState(false);
  const getGalleyData = async () => {
    setLoading(true);
    try {
      const response = await SendPostRequest("gallery/list");
      if (!response?.data || response?.data.length < 1) {
        setIsData(true);
      } else {
        setGalleryData(response.data);
      }
    } catch (error) {
      console.error("Error fetching gallery data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <div class="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Gallery" Image="theme-2-banner-gallery.webp" />

        <div className="row portfolio-wrap popup-gallery py-5 my-4">
          {loading ? (
            <div className="col-12 text-center">
              <Spinner />
            </div>
          ) : galleryData.length > 0 ? (
            galleryData.map((item, index) => (

              <div
                class="portfolio-item portfolio-overlay-wrap col-lg-4 col-md-6 filter kitchen full-width-gallery-design">
                <div class="portfolio-thumb relative o-hide">
                  <Link to={`/gallery/${item?.uid}`} class="popup-img" title="Gallery 1">
                    <img src={item.gallery_image} class="img-fluid" style={{ width: "100%", height: "auto", borderRadius: "none" }}
                      alt="" title="Invest Advices" />
                  </Link>
                  <div class="portfolio-wrap grid-view-gallery-overlay">
                    <div class="portfolio-details-overlay">
                      <div class="portfolio-icons">
                        <Link to={`/gallery/${item?.uid}`} class="popup-img" title="Gallery 1">
                          <i class="ti-plus text-white"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            ))
          ) : (
            <div className="col-12 text-center my-5 py-3">
              <h3>No Record Available</h3>
            </div>
          )}
        </div>

        <FooterWrapper />
      </div>
    </div>
  );
}

export default FullWidthGridGallery;
